export default "__VITE_ASSET__4A8uod$U__"